import DonationComponentTwoColumn from "./DonationComponentTwoColumn";

const EmptyMessage=({msgTitle, msgData, noteSection,children})=>{
    return(
        <div className={`${noteSection?`pb-4 -mt-5 text-center`:`w-full pb-16`} alim-text-color-style`}>
            <h2 className='mb-8'>{msgTitle}</h2>
            <p className={`${noteSection?`text-[30px]`:``}`}>{msgData}</p>
            {children}
        </div>
    );
}

export default EmptyMessage;